import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// Import Containers
import { DefaultLayoutComponent } from './containers';

import { P404Component } from './pages/error/404.component';
import { P500Component } from './pages/error/500.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './views/register/register.component';
import { AuthGuard, YearChangeGuard, TahunAnggaranGuard } from './_services/auth/auth.guard';
import * as path from 'path';
import { SkpdGuard } from './pages/skpd/skpd.guard';
import { SkpdRequiredGuard } from './pages/shared/skpd-required.guard';
import { TapdGuard } from './pages/pengguna/tapd.guard';
import { TahunAnggaranComponent } from './pages/shared/tahun-anggaran/tahun-anggaran.component';


export const routes: Routes = [
  {
    path: 'tahun-anggaran',
    component: TahunAnggaranComponent,
    canActivate: [TahunAnggaranGuard]
  },
  {
    path: '',
    redirectTo: 'tahun-anggaran',
    pathMatch: 'full'
  },
  {
    path: '404',
    component: P404Component,
    data: {
      title: 'Page 404'
    }
  },
  {
    path: '500',
    component: P500Component,
    data: {
      title: 'Page 500'
    }
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      title: 'Login Page'
    }
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      title: 'Register Page'
    }
  },
  {
    path: ':year',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home'
    },
    canActivate: [AuthGuard, YearChangeGuard],
    children: [
      // {
      //   path : '',
      //   redirectTo: 'dashboard',
      //   pathMatch: 'full'
      // },
      {
        path: 'monitoring',
        canActivate: [SkpdRequiredGuard],
        loadChildren: () => import('./pages/monitoring/monitoring.module').then(m => m.MonitoringModule)
      },
      {
        path: 'dashboard',
        canActivate: [SkpdRequiredGuard],
        loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'master',
        canActivate: [SkpdRequiredGuard],
        loadChildren: () => import('./pages/master/master.module').then(m => m.MasterModule)
      },
      {
        path: 'monitoring',
        canActivate: [SkpdRequiredGuard],
        loadChildren: () => import('./pages/monitoring/monitoring.module').then(m => m.MonitoringModule)
      },

      {
        path: 'pendapatan',
        canActivate: [SkpdRequiredGuard],
        loadChildren: () => import('./pages/master/pendapatan/pendapatan.module').then(m => m.PendapatanModule),
        data: {
          title: 'Pendapatan',
          breadcrumb: 'Pendapatan'
        },
      },
      {
        path: 'belanja',
        canActivate: [SkpdRequiredGuard],
        loadChildren: () => import('./pages/master/belanja/belanja.module').then(m => m.BelanjaModule),
        data: {
          title: 'Belanja'
        },
      },
      {
        path: 'pembiayaan',
        canActivate: [SkpdRequiredGuard],
        loadChildren: () => import('./pages/master/pembiayaan/pembiayaan.module').then(m => m.PembiayaanModule),
        data: {
          title: 'Belanja'
        },
      },
      {
        path: 'laporan',
        canActivate: [SkpdRequiredGuard],
        loadChildren: () => import('./pages/master/laporan/laporan.module').then(m => m.LaporanModule),
        data: {
          title: 'Laporan'
        },
      },
      {
        path: 'ambang-batas',
        canActivate: [SkpdRequiredGuard],
        loadChildren: () => import('./pages/master/ambang-batas/ambang-batas.module').then(m => m.AmbangBatasModule),
        data: {
          title: 'Ambang Batass'
        }
      },
      // {
      //   path: 'sumber-dana',
      //   canActivate: [SkpdRequiredGuard],
      //   loadChildren: () => import('./pages/master/sumber-dana/sumber-dana.module').then(m => m.SumberDanaModule),
      //   data: {
      //     title: 'Sumber Dana'
      //   }
      // },
      {
        path: 'forward-estimate',
        canActivate: [SkpdRequiredGuard],
        loadChildren: () => import('./pages/master/forward-estimate/forward-estimate.module').then(m => m.forwardEstimateModule),
        data: {
          title: 'Forward Estimate'
        }
      },
      {
        path: 'skpd',
        loadChildren: () => import('./pages/skpd/skpd.module').then(m => m.SkpdModule),
        data: {
          title: 'SKPD'
        },
        canActivate: [SkpdGuard]
      },
      {
        path: 'fase',
        loadChildren: () => import('./pages/fase/fase.module').then(m => m.FaseModule),
        data: {
          title: 'Fase'
        },
        canActivate: [SkpdGuard]
      },
      {
        path: 'batas-inputan',
        loadChildren: () => import('./pages/batas-inputan/batas-inputan.module').then(m => m.BatasInputanModule),
        data: {
          title: 'Batas Inputan'
        },
        canActivate: [SkpdGuard]
      },
      {
        path: 'konfirmasi-fase',
        loadChildren: () => import('./pages/konfirmasi-fase/konfirmasi-fase.module').then(m => m.KonfirmasiFaseModule),
        data: {
          title: 'Konfirmasi Fase'
        }
      },
      {
        path: 'pengguna',
        loadChildren: () => import('./pages/pengguna/pengaturan/pengaturan.module').then(m => m.PengaturanModule),
        data: {
          title: 'Pengguna'
        }, 
        canActivate: [TapdGuard]
      },
      {
        path: 'pengguna-skpd',
        loadChildren: () => import('./pages/pengguna/pengaturan/pengaturan.module').then(m => m.PengaturanModule),
        data: {
          title: 'Pengguna - SKPD'
        },
        canActivate: [TapdGuard]
      }

    ]
  },
  {
    path: `**`,
    redirectTo: `404`,
    pathMatch: 'full'
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
